import type { PlanComparisonRow } from "@/types/plans";

function Cell({ value }: { value: string }) {
  if (value === "—") {
    return (
      <span className="flex items-center justify-center text-foreground-300">
        <i className="ri-subtract-line text-base" />
      </span>
    );
  }
  if (value === "Included") {
    return (
      <span className="flex items-center justify-center text-secondary-600">
        <i className="ri-check-line text-lg" />
      </span>
    );
  }
  return <span className="text-sm font-medium text-foreground-800">{value}</span>;
}

interface ComparisonTableProps {
  rows: PlanComparisonRow[];
}

export default function ComparisonTable({ rows }: ComparisonTableProps) {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] border-collapse text-left">
          <thead>
            <tr className="bg-background-100">
              <th className="px-6 py-4 font-heading text-sm font-bold text-foreground-950">
                Feature
              </th>
              <th className="px-6 py-4 text-center font-heading text-sm font-bold text-foreground-950">
                Free
              </th>
              <th className="px-6 py-4 text-center font-heading text-sm font-bold text-primary-700">
                Business
              </th>
              <th className="px-6 py-4 text-center font-heading text-sm font-bold text-foreground-950">
                Premium
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr
                key={row.id}
                className={index % 2 === 1 ? "bg-background-50" : "bg-background-50/60"}
              >
                <td className="border-t border-background-200 px-6 py-3.5 text-sm text-foreground-700">
                  {row.feature}
                </td>
                <td className="border-t border-background-200 px-6 py-3.5 text-center">
                  <Cell value={row.free} />
                </td>
                <td className="border-t border-background-200 bg-primary-50/50 px-6 py-3.5 text-center">
                  <Cell value={row.business} />
                </td>
                <td className="border-t border-background-200 px-6 py-3.5 text-center">
                  <Cell value={row.premium} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}